<template>
  <div class="ylj-detail-page">
    <van-nav-bar title="养老金明细" left-arrow @click-left="$router.back()" />
    <div class="detail-total">
      <div class="detail-total-title">养老金余额</div>
      <div class="detail-total-money">{{ formatMoney(balance) }}<small> 元</small></div>
    </div>
    <div class="detail-list">
      <div v-if="list.length">
        <div class="detail-item" v-for="item in list" :key="item.id">
          <div class="detail-item-left">
            <div class="detail-item-title">{{ getSourceTitle(item.source_type) }}</div>
            <div class="detail-item-time">{{ item.created_at }}</div>
            <div v-if="item.remark" class="detail-item-remark">{{ item.remark }}</div>
          </div>
          <div class="detail-item-right">
            <div class="detail-amount" :class="{reduce:Number(item.amount)<0}">
              {{ formatAmount(item.amount) }}
            </div>
            <div class="detail-after">余额 {{ formatMoney(item.after_money) }}</div>
          </div>
        </div>
      </div>
      <div v-else class="detail-empty">暂无养老金明细</div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default{
  name:"YljDetail",
  data(){
    return{
      balance:0,
      list:[],
      page:1,
      loading:false,
      finished:false
    };
  },
  created(){
    this.getData();
  },
  methods:{
    formatMoney(num){
      return Number(num||0).toLocaleString("zh-CN");
    },
    formatAmount(num){
      const n=Number(num||0);
      return (n>=0?"+":"-")+this.formatMoney(Math.abs(n));
    },
    getSourceTitle(type){
      type=Number(type);
      if(type===1)return "每日签到";
      if(type===2)return "邀请好友";
      if(type===3)return "后台调整";
      return "养老金变动";
    },
    getData(){
      if(this.loading||this.finished)return;
      this.loading=true;
      request.get("/pension/index",{},{login:true}).then(res=>{
        if(res&&res.data&&res.data.data){
          this.balance=Number(res.data.data.balance||0);
        }
        return request.get("/pension/sign/log",{page:this.page},{login:true});
      }).then(res=>{
        if(res&&res.data&&res.data.data){
          const data=res.data.data;
          const rows=data.list||[];
          this.list=this.list.concat(rows);
          if(rows.length<20){
            this.finished=true;
          }else{
            this.page++;
          }
        }
      }).catch(err=>{
        console.log(err);
        if(err.response&&err.response.data){
          this.$dialog.error(err.response.data.msg);
        }
      }).finally(()=>{
        this.loading=false;
      });
    }
  }
};
</script>

<style scoped>
.ylj-detail-page{
  min-height:100vh;
  background:#f6f7f9;
}
.detail-total{
  margin:12px;
  padding:22px 20px;
  border-radius:12px;
  background:#fff;
  text-align:center;
}
.detail-total-title{
  color:#999;
  font-size:14px;
}
.detail-total-money{
  margin-top:8px;
  color:#e53935;
  font-size:30px;
  font-weight:bold;
}
.detail-total-money small{
  font-size:14px;
  font-weight:normal;
}
.detail-list{
  margin:12px;
  background:#fff;
  border-radius:12px;
  overflow:hidden;
}
.detail-item{
  display:flex;
  justify-content:space-between;
  padding:16px;
  border-bottom:1px solid #f1f1f1;
}
.detail-item:last-child{
  border-bottom:0;
}
.detail-item-title{
  color:#333;
  font-size:15px;
  font-weight:bold;
}
.detail-item-time{
  margin-top:6px;
  color:#999;
  font-size:12px;
}
.detail-item-remark{
  margin-top:5px;
  color:#999;
  font-size:12px;
}
.detail-item-right{
  text-align:right;
}
.detail-amount{
  color:#e53935;
  font-size:16px;
  font-weight:bold;
}
.detail-amount.reduce{
  color:#333;
}
.detail-after{
  margin-top:6px;
  color:#999;
  font-size:12px;
}
.detail-empty{
  padding:50px 20px;
  color:#999;
  font-size:14px;
  text-align:center;
}
</style>
